import CallAutom from './CallAutom/CallAutom';
import { types } from './types';

//Enter the switch according to the incoming action names, it renders.
function Actions(action, variables, setOpenVariable, variableRender, automVersionId, automId, setVariables, automDetail, setAutomDetail) {
    console.log('action.actionName? ', action.actionName)
    switch (action.actionName) {
        case types.CALLAUTOM:
            return <CallAutom action={action} variableRender={variableRender} variables={variables}
                setOpenVariable={setOpenVariable} automVersionId={automVersionId} automId={automId} setVariables={setVariables}
                automDetail={automDetail} setAutomDetail={setAutomDetail} />
        default: break;
    }
}
export default Actions;